import { NgModule } from '@angular/core';
import { AncillaryServicesService } from "./useCases/ancillary-services.service";
import { PropalModule } from "../../service/propal/propal.module";
import {
    CacheQuotedAvailabilityModule
} from "app_locobook/service/cache-quoted-availability/cache-quoted-availability.module";
import {
    AirBookingConditionApplyService
} from "app_locobook/domain/ancillaryServices/useCases/air-booking-condition-apply.service";
import { AirQuoteResourceModule } from "libraries/service/resources/airQuote/airQuoteResource.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";
import { AirBookingResourceModule } from "libraries/service/resources/air-booking/air-booking-resource.module";

@NgModule({
    imports: [
        AirBookingResourceModule,
        AirQuoteResourceModule,
        CacheQuotedAvailabilityModule,
        ConfigurationResourceModule,
        LocalizedModule,
        PropalModule,
    ],
    providers: [
        AncillaryServicesService,
        AirBookingConditionApplyService,
    ],
})
export class AncillaryServicesDomainModule {}
